import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

export function Header() {
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `text-sm ${isActive ? "text-ink font-medium" : "text-ink/60 hover:text-ink"}`;

  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    setSignedIn(Boolean(localStorage.getItem("session")));
  }, []);

  return (
    <header className="border-b border-ink/10">
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-semibold">
          <img src="/favicon.svg" alt="" className="w-6 h-6" />
          <span>Chart to CSV</span>
        </Link>
        <nav className="flex items-center gap-6">
          <NavLink to="/accuracy" className={linkClass}>
            Accuracy
          </NavLink>
          <NavLink to="/pricing" className={linkClass}>
            Pricing
          </NavLink>
          <NavLink to="/login" className={linkClass}>
            {signedIn ? "Account" : "Sign in"}
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
